<template>
  <div :class="$style.detail">
    <DetailHeader :headerData="headerData" />
    <div>
      <a-tabs
        :default-active-key="activeKey"
        :tabBarStyle="{ margin: '10px 20px' }"
        @change="changeTab"
      >
        <!-- <a-tab-pane key="device-status" :tab="$t('safety.deviceStatus')">
          <div v-if="activeKey === 'device-status'" :class="$style.listWrap">
            <StatusInfo
              :textObj="baseInfoText"
              :label="$t('detail.baseInfo')"
              :showUnit="true"
            />
          </div>
        </a-tab-pane> -->
        <a-tab-pane key="device-status" tab="设备数据">
          <div v-if="activeKey === 'device-status'" :class="$style.listWrap">
            <DeviceStatus :deviceId="deviceId" :pageType="pageType" />
          </div>
        </a-tab-pane>
        <a-tab-pane key="device-warning">
          <span slot="tab">
            <a-badge
              style="width: 40px;"
              :count="alarmCount"
              :number-style="{
                backgroundColor: 'var(--primary)',
                boxShadow: '0 0 0 1px var(--primary) inset',
                top: '-5px',
              }"
            >
              {{ $t('safety.alarm') }}
            </a-badge>
          </span>
          <div v-if="activeKey === 'device-warning'" :class="$style.listWrap">
            <SmokeWarning :deviceId="deviceId" :pageType="pageType" />
          </div>
        </a-tab-pane>
        <div v-if="updateTime" slot="tabBarExtraContent">
          <a-icon type="sync" :class="$style.refresh" @click="refreshData" />
          <span>{{ formateTime(updateTime) }}</span>
        </div>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator';
import DetailHeader from '@/views/safety-device/component/detail-header';
import SmokeWarning from './smoke-warning';
import ScreenSelect from '@/views/safety-device/component/screen-select';
// import StatusInfo from '@/views/safety-device/component/status-info';
import { deviceTypeEnum } from '@/enum/device';
import {
  deviceSmokeInfo,
  refreshSmokeInfo,
} from '@/services/device-manage/device-detail';
import DeviceStatus from './device-status';

@Component({
  components: {
    DetailHeader,
    SmokeWarning,
    ScreenSelect,
    // StatusInfo,
    DeviceStatus,
  },
})
export default class ElectricityMeterDetail extends Vue {
  @Prop({ type: Object, default: () => {} }) detailData;
  @Prop({ type: String, default: '' }) pageType;

  headerData = {};
  mounted() {
    this.initHeadData();
  }
  baseInfoText = {
    smokeDeviceType: {
      text: this.$t('detail.deviceType'),
      unit: '',
      value: '-',
    },
    smokeDeviceModel: {
      text: this.$t('detail.deviceMode'),
      unit: '',
      value: '-',
    },
    rssi: {
      text: this.$t('detail.signalStrength'),
      unit: '',
      value: '-',
    },
    voltage: {
      text: this.$t('detail.voltage'),
      unit: '%',
      value: '-',
    },
    temperature: {
      text: this.$t('safety.temperature'),
      unit: '℃',
      value: '-',
    },
  };
  alarmCount = 0;
  deviceId = '';
  smokeDeviceType = '-';
  smokeDeviceModel = '-';
  initHeadData() {
    const data = this.detailData;
    this.headerData = {
      deviceName: data.deviceName,
      deviceCode: data.deviceCode,
      bindTime: data.bindTime,
      projectName: data.projectName,
      remark: data.remark,
    };
    this.alarmCount =
      data.alarmCount !== 0 && data.alarmCount !== -1 ? data.alarmCount : 0;
    this.deviceId = data.pkId;
    if (data.extData) {
      this.smokeDeviceType = data.extData.type;
      this.smokeDeviceModel = data.extData.model;
    }
    this.getInfoList();
  }
  get deviceGroup() {
    return deviceTypeEnum[this.pageType].deviceGroup;
  }
  updateTime = '';
  async getInfoList() {
    try {
      const res = await deviceSmokeInfo(this.deviceId, this.deviceGroup);
      this.baseInfoText.smokeDeviceType.value = this.smokeDeviceType;
      this.baseInfoText.smokeDeviceModel.value = this.smokeDeviceModel;
      this.baseInfoText.rssi.value = res.rssi !== -1 ? res.rssi : '-';
      this.baseInfoText.voltage.value = res.voltage !== -1 ? res.voltage : '-';
      this.baseInfoText.temperature.value =
        res.temperature !== -1 ? res.temperature : '-';
      this.updateTime = res.updateTime;
    } catch {
      return false;
    }
  }
  activeKey = 'device-status';
  changeTab(activeKey) {
    this.activeKey = activeKey;
    if (activeKey === 'device-status') {
      this.getInfoList();
    }
  }
  formateTime(t) {
    return t ? this.dayjs(t).format('YYYY-MM-DD HH:mm:ss') : '-';
  }
  async refreshData() {
    try {
      const res = await refreshSmokeInfo(this.deviceId, this.deviceGroup);
      this.baseInfoText.smokeDeviceType.value = this.smokeDeviceType;
      this.baseInfoText.smokeDeviceModel.value = this.smokeDeviceModel;
      this.baseInfoText.rssi.value = res.rssi !== -1 ? res.rssi : '-';
      this.baseInfoText.voltage.value = res.voltage !== -1 ? res.voltage : '-';
      this.baseInfoText.temperature.value =
        res.temperature !== -1 ? res.temperature : '-';
      this.updateTime = res.updateTime;
    } catch {
      return false;
    }
  }
}
</script>

<style lang="less" module>
@import '@/views/safety-device/component/safety.less';
.refresh {
  color: var(--primary);
  cursor: pointer;
  margin-right: 10px;
}
.label {
  margin: 10px 0;
}
</style>
